import { useEffect, useState } from 'react'

// True when the Grammarly browser extension is present on the page. Grammarly injects its
// own editor overlay into text fields and marks the document, so we detect it to (a) suppress
// it on our smart field and (b) offer a "let Grammarly check grammar" mode. It attaches
// asynchronously, so we observe the DOM rather than checking once.
export function useGrammarly(): boolean {
  const [present, setPresent] = useState(false)

  useEffect(() => {
    const detect = () =>
      !!document.querySelector('grammarly-desktop-integration, grammarly-extension') ||
      document.documentElement.hasAttribute('data-gr-ext-installed') ||
      document.body.hasAttribute('data-gr-ext-installed')

    if (detect()) {
      setPresent(true)
      return
    }

    const check = () => detect() && setPresent(true)
    const observer = new MutationObserver(check)
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-gr-ext-installed'] })
    observer.observe(document.body, { childList: true, attributes: true, attributeFilter: ['data-gr-ext-installed'] })
    const timer = setTimeout(check, 1500) // Grammarly can inject after first paint

    return () => {
      observer.disconnect()
      clearTimeout(timer)
    }
  }, [])

  return present
}
